module.exports = __webpack_public_path__ + "img/menu_gomb_dpc_aktiv.9f7d5e11.png";